// or get from process.env.REACT_APP_{var} to handle PROD and DEV environments
export const APP_VERSION = '1.0.0';
export const API_BASE_URL = 'https://1000containers.com/api';
// export const API_BASE_URL = 'http://localhost:8000/api';
// export const API_BASE_URL = 'http://74.208.61.158:3001/api';

/** Related-product "internal ads" sidebar on the desktop product page. */
export const ENABLE_INTERNAL_ADS = false;

export default {};
